/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
    name: 'userSlice',
    initialState: {
        profile: null,
    },
    reducers: {
        setUser: (state, action) => {
            state.profile = action.payload;
        },
        destroyUser: (state) => {
            state.profile = null;
            localStorage.clear();
        },
    },
});
export const { setUser, destroyUser } = userSlice.actions;

export default userSlice.reducer;
